import { render, staticRenderFns } from "./BillingReview.vue?vue&type=template&id=a445f6a4"
import script from "./BillingReview.vue?vue&type=script&lang=ts"
export * from "./BillingReview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports